import {
  KVMeasurementSegment,
  KVMeasurementSegmentJSON,
} from './KVMeasurementSegment'

export type KVMeasurementJSON = {
  measurementId: string
  measurementVisible: boolean
  measurementLabel: string
  measurementSegments: KVMeasurementSegmentJSON[]
  isMeasurementFinalized?: boolean
}

export class KVMeasurement {
  id: string
  visible: boolean
  label: string
  segments: KVMeasurementSegment[]
  isMeasurementFinalized?: boolean

  constructor(id: string) {
    this.id = id
    this.segments = []
    this.visible = true
    this.label = ''
    this.isMeasurementFinalized = false
  }

  static fromJSON(json: KVMeasurementJSON): KVMeasurement {
    const measurement = new KVMeasurement(json.measurementId)
    if (json.measurementVisible !== undefined)
      measurement.visible = json.measurementVisible
    if (json.measurementLabel) measurement.label = json.measurementLabel
    if (json.measurementSegments) {
      measurement.segments = json.measurementSegments.map(
        KVMeasurementSegment.fromJSON
      )
    }
    if (json.isMeasurementFinalized !== undefined)
      measurement.isMeasurementFinalized = json.isMeasurementFinalized
    return measurement
  }

  static toJSON(measurement: KVMeasurement): KVMeasurementJSON {
    return {
      measurementId: measurement.id,
      measurementSegments: measurement.segments.map(
        KVMeasurementSegment.toJSON
      ),
      measurementVisible: measurement.visible,
      measurementLabel: measurement.label,
    }
  }
}
